<template>
  <v-card elevation="0" class="mb-2">
    <v-card-actions>
      <v-spacer></v-spacer>
      <span style="color:#999">Drive time radius </span> 
      <v-btn-toggle
        v-model="driveTimeToggle"
        mandatory
        dense
        color="primary"
        class="ml-4"
      >
        <v-btn v-for="dt in driveTimeOptions" v-text="dt" />
      </v-btn-toggle>      
      <v-spacer></v-spacer>
      
    </v-card-actions>
  </v-card>
</template>
<script>
import { mapState } from 'vuex'
export default {
  computed: {
      driveTimeToggle: {
      get() {
        return this.driveTimeOptions.indexOf(this.drive_time)
      },
      set(value) {
        this.$store.dispatch('updateState', ['drive_time', this.driveTimeOptions[value]]).then(resolution => {
          this.$emit('drive-time-changed');
        })
      }

    },
    ...mapState({
      driveTimeOptions: state => state.driveTimeOptions,
      drive_time: state => state.drive_time
    })

  }  
}
</script>